<template>
  <div class="settings-wrp" :key="$route.path">
    <div class="settings-title">
      {{ t('Domains') }}
    </div>
    <div class="settings-content">
      <ui-tabs styleType="style-list" :tabs="tabs">
        <template #content-tracking="{ props }">
          <DomainsTracking v-bind="props" />
        </template>
        <template #content-cloaking="{ props }">
          <DomainsCloaking v-bind="props" />
        </template>
      </ui-tabs>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from '@/composables';
import DomainsCloaking from './forms/cloaking.vue';
import DomainsTracking from './forms/tracking.vue';

const { t } = useI18n();

const tabs = computed(() => [
  {
    label: t('Tracking'),
    key: 'tracking',
  },
  {
    label: t('Cloaking'),
    key: 'cloaking',
  },
]);
</script>

<style lang="scss" scoped></style>
